<template>
  <transition mode="out-in" name="fade">
    <FullscreenLoader key="loader" v-if="$store.state.globalLoading">{{$t('general.loading_experience')}}</FullscreenLoader>
    <div style="width:100%;height:100%" key="content" v-else>
      <slot></slot>
    </div>
  </transition>
</template>

<script>
    import FullscreenLoader from "../general/FullscreenLoader";
    export default {
        components: {FullscreenLoader},
        name: "data-load",
    }
</script>

<style scoped>

</style>
